module.exports = __webpack_public_path__ + "static/floating-action-button-mobile-only-do-fe54eb51807a8ec2ec060a6ac1830da3.png";